import './Mgmt';
import './Jadwal';
import './Kontak';
// import './Master';

import Route from './Routes';

export default Route;